// Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved.

import { IManageUser } from './user';

export interface ILicensedDrive {
    id: number;
    disk_serial: string;
    custom_text_1: string;
    custom_text_2: string;
    sub_id: string;
    pba_license_id?: string;
    pba_license?: IPbaLicense;
    license_key?: string;
    created_dttm: string;
    last_generated?: string;
    checked?: boolean;
    background?: string;
    maint_exp_timestamp?: string;
}

export interface IPbaLicense {
    id: number;
    group_id: number;
    sub_id: number;
    created_dttm: string;
    request_code: string;
    license_key: string;
    maint_exp_timestamp: string;
}

export interface IAssignedDrivesResponse {
    licenses_used: number;
    subscription_count: number;
    pba_licenses: { [key: string]: IPbaLicense };
    pba_licenses_count: number;
    licenses: ILicensedDrive[];
}

export interface INewPbaSerialResponse {
    success: boolean;
    new_serials: string[];
    bad_serials?: string[];
    status: string;
    licenses_used: number;
    subscription_count: number;
    licenses: ILicensedDrive[];
}

export interface IUpdatePbaSerialRequest {
  subscription_id: string;
  disk_serial: string;
  custom_text_1: string;
  custom_text_2: string;
}

export interface IBulkUpdatePbaSerialRequest {
  pba_serial_ids: number[];
  custom_text_1?: string;
  custom_text_2?: string;
}

export interface IBatchUpdateDialogResult {
  update1: boolean;
  custom1: string;
  update2: boolean;
  custom2: string;
}

export interface IFdeLicense {
    created_dttm: string;
    custom_text_1: string;
    custom_text_2: string;
    fde_license_id: number | null;
    fde_serial_uuid: string;
    group_id: number;
    id: number;
    last_generated: string | null;
    license_key: string | null;
    maintenance_exp_dttm: string | null;
    sub_id: number;
    upload_code: string | null;
}

export interface IFdeLicenseResponse {
    fdeLicenses: IFdeLicense[];
    subscriptionCount: number;
    totalFiltered: number;
    totalLicensed: number;
    totalSerials: number;
}

export enum SerialLicensingOption {
    NO_LICENSE = 0,
    NEW_SERIALS_LICENSED = 1,
    UNLICENSED_SERIALS_LICENSED = 2,
    ALL_EXISTING_LICENSED = 3
}

export interface IAddFdeSerialData {
    subscriptionId: string;
    selectedOrgId: string;
    user: IManageUser;
    maintenanceExpiration: Date;
    totalLicensed: number;
    totalSerials: number;
}

export interface IAddWorkstationsRequest{
    serials: string[];
    subscription_id: string;
    licensing_option: SerialLicensingOption;
    maintenance_date: string;
}

export type SortInput = { active?: string; direction?: 'asc' | 'desc' };

export interface IFdeQuerySort {
    attr: string;
    desc: boolean;
}

export interface IFdeQuery {
  selectedOrgId: string;
  pageStart: number;
  pageSize: number;
  subscriptionId: string;
  assigned: boolean | null;
  sorts: IFdeQuerySort[];
}
